import { render } from "./Widget.ce.vue?vue&type=template&id=58b7c6d2"
import script from "./Widget.ce.vue?vue&type=script&lang=js"
export * from "./Widget.ce.vue?vue&type=script&lang=js"

import _style_0 from "./Widget.ce.vue?vue&type=style&index=0&id=58b7c6d2&inline&lang=css"

import exportComponent from "/home/webmaster/lightning-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__